import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Search } from "./search";
import { faDiscord, faPatreon, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import styles from "./index.module.scss";
import Fruit from "../assets/img/fruit.svg";
import Dog from "../assets/img/dog.svg";
export var App = function () {
    var _a = useState(false), searchVis = _a[0], setSearchVis = _a[1];
    var _b = useState(""), search = _b[0], setSearch = _b[1];
    return React.createElement("div", { className: styles.container },
        React.createElement("header", { className: styles.header },
            React.createElement("div", { className: styles.title },
                React.createElement(Fruit, { className: styles.icon }),
                React.createElement("h1", null, "YUZU Nippon")),
            React.createElement("ul", null,
                React.createElement("li", { className: styles.icons },
                    React.createElement("div", null,
                        React.createElement(FontAwesomeIcon, { icon: faTwitter })),
                    React.createElement("div", null,
                        React.createElement(FontAwesomeIcon, { icon: faDiscord })),
                    React.createElement("div", null,
                        React.createElement(FontAwesomeIcon, { icon: faPatreon }))),
                React.createElement("li", null,
                    React.createElement("div", null, "Cours de japonais"),
                    React.createElement("ul", null,
                        React.createElement("li", null, "Grands d\u00E9butants : introduction g\u00E9n\u00E9rale"),
                        React.createElement("li", null,
                            "\u00C9criture",
                            React.createElement("ul", null,
                                React.createElement("li", null, "Kana"),
                                React.createElement("li", null, "Kanji"))),
                        React.createElement("li", null, "Le\u00E7ons"),
                        React.createElement("li", null, "Vocabulaire th\u00E9matique"),
                        React.createElement("li", null, "Points de grammaire"),
                        React.createElement("li", null, "Japonais classique"))),
                React.createElement("li", null,
                    React.createElement("div", null, "M\u00E9thodes d'apprentissage"),
                    React.createElement("ul", null,
                        React.createElement("li", null, "Quel manuel choisir ?"),
                        React.createElement("li", null, "Autodidactes : conseils pour se lancer"),
                        React.createElement("li", null, "Japonais \u00E0 l'Universit\u00E9"),
                        React.createElement("li", null, "Japonais dans la vie quotidienne"))),
                React.createElement("li", null,
                    React.createElement("div", null, "\u00C0 propos du Japon"),
                    React.createElement("ul", null,
                        React.createElement("li", null, "Histoire du Japon"),
                        React.createElement("li", null, "Soci\u00E9t\u00E9 japonaise"),
                        React.createElement("li", null, "\u00C9l\u00E9ments de culture basiques"),
                        React.createElement("li", null, "Voyager au Japon"),
                        React.createElement("li", null, "Calendrier"))),
                React.createElement("li", null, "Contact"),
                React.createElement("li", null, "Cr\u00E9dits"),
                React.createElement("li", { className: styles.icons },
                    React.createElement("div", null,
                        React.createElement(FontAwesomeIcon, { icon: faSearch, onClick: function () {
                                setSearchVis(function (s) { return !s; });
                                setSearch("");
                            } })))),
            React.createElement(Search, { visible: searchVis, content: search, onChange: setSearch, onConfirm: function () {
                    console.log("Searching for " + search + "...");
                } })),
        React.createElement(Dog, { className: styles.dog }));
};
